import React from "react";
import Image from "react-bootstrap/Image";
import { Typography } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../_metronic/utils/utils";
const Illustration = ({
  imageSource,
  description,
  guidance,
  size,
  descriptionLeftIcon,
  descriptionRightIcon,
  guidanceLeftIcon,
  guidanceRightIcon,
}) => {
  if (typeof size === "undefined") {
    size = "lg";
  }
  return (
    <div className="d-flex justify-content-center">
      <div className="column">
        <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
          <React.Fragment>
            <Typography component="span" align="center">
              <Image
                src={toAbsoluteUrl(`/invifo/illustrations/${imageSource}`)}
                style={{
                  height: "auto",
                  width: `${
                    size === "lg"
                      ? "300px"
                      : size === "md"
                      ? "250px"
                      : size === "sm"
                      ? "150px"
                      : "300px"
                  }`,
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                alt=""
                fluid
              />
            </Typography>
          </React.Fragment>
        </div>
        {description ? (
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
            <React.Fragment>
              <Typography component="span" align="center">
                <div className="illustration-description text-center">
                  {descriptionLeftIcon ? (
                    <i className={`${descriptionLeftIcon} mr-1`}></i>
                  ) : null}
                  {description}
                  {descriptionRightIcon ? (
                    <i className={`${descriptionRightIcon} ml-1`}></i>
                  ) : null}
                </div>
              </Typography>
            </React.Fragment>
          </div>
        ) : null}
        {guidance ? (
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
            <React.Fragment>
              <Typography component="span" align="center">
                <div className="illustration-guidance text-center">
                  {guidanceLeftIcon ? (
                    <i className={`${guidanceLeftIcon} mr-1`}></i>
                  ) : null}
                  {guidance}
                  {guidanceRightIcon ? (
                    <i className={`${guidanceRightIcon} ml-1`}></i>
                  ) : null}
                </div>
              </Typography>
            </React.Fragment>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Illustration;
